export const DEFAULT_MESSAGE = 'Reload site? Changes you made may not be saved';
